export enum ImportOrderValidationSubstituteTypeEnum {
  REPLACEMENT = 'replacement',
}
//https://usfoods.atlassian.net/wiki/spaces/R4O/pages/268861562/Import+Order+Error+Codes
export enum ImportOrderValidationErrorTypeEnum {
  CRITICAL = 'Critical',
  MINOR = 'Minor',
  CRITICAL_ERROR_100 = '100', //Missing Customer Number
  CRITICAL_ERROR_101 = '101', //The customer number was not recognized
  CRITICAL_ERROR_102 = '102', //Ordering is currently not available...
  CRITICAL_ERROR_103 = '103', //The Division Number is not Valid...
  CRITICAL_ERROR_104 = '104', //Invalid Department Number
  CRITICAL_ERROR_105 = '105', //The Department Number is not Valid...
  CRITICAL_ERROR_106 = '106', //The department number is not valid...
  CRITICAL_ERROR_1000 = '1000', //Unable to Verify
  MINOR_ERROR_1001 = '1001', //Invalid Each Quantity
  MINOR_ERROR_1002 = '1002', //Invalid Case Quantity
  CRITICAL_ERROR_1003 = '1003', //Product Is Discontinued
  CRITICAL_ERROR_1004 = '1004', //Chef Store Product
  CRITICAL_ERROR_1005 = '1005', //Product Not Found
  CRITICAL_ERROR_1006 = '1006', //Special Order Product
  MINOR_ERROR_1007 = '1007', //Product out of stock
  CRITICAL_ERROR_1008 = '1008', //Unable to Order...
  CRITICAL_ERROR_1009 = '1009', //Unable to Order...
  CRITICAL_ERROR_1010 = '1010', //Invalid Order Quantity
  CRITICAL_ERROR_1011 = '1011', //Temporarily Available from Manufacturer
  CRITICAL_ERROR_1012 = '1012', //Out of stock. We are working...
}
export const CRITICAL_ERRORS: String[] = [
  ImportOrderValidationErrorTypeEnum.CRITICAL_ERROR_100,
  ImportOrderValidationErrorTypeEnum.CRITICAL_ERROR_101,
  ImportOrderValidationErrorTypeEnum.CRITICAL_ERROR_102,
  ImportOrderValidationErrorTypeEnum.CRITICAL_ERROR_103,
  ImportOrderValidationErrorTypeEnum.CRITICAL_ERROR_104,
  ImportOrderValidationErrorTypeEnum.CRITICAL_ERROR_105,
  ImportOrderValidationErrorTypeEnum.CRITICAL_ERROR_106,
  ImportOrderValidationErrorTypeEnum.CRITICAL_ERROR_1000,
  ImportOrderValidationErrorTypeEnum.CRITICAL_ERROR_1003,
  ImportOrderValidationErrorTypeEnum.CRITICAL_ERROR_1004,
  ImportOrderValidationErrorTypeEnum.CRITICAL_ERROR_1005,
  ImportOrderValidationErrorTypeEnum.CRITICAL_ERROR_1006,
  ImportOrderValidationErrorTypeEnum.CRITICAL_ERROR_1008,
  ImportOrderValidationErrorTypeEnum.CRITICAL_ERROR_1009,
  ImportOrderValidationErrorTypeEnum.CRITICAL_ERROR_1010,
  ImportOrderValidationErrorTypeEnum.CRITICAL_ERROR_1011,
  ImportOrderValidationErrorTypeEnum.CRITICAL_ERROR_1012,
];
export const MINOR_ERRORS: String[] = [
  ImportOrderValidationErrorTypeEnum.MINOR_ERROR_1001,
  ImportOrderValidationErrorTypeEnum.MINOR_ERROR_1002,
  ImportOrderValidationErrorTypeEnum.MINOR_ERROR_1007,
];

/**
 * Error codes for order items that are included on validation page download
 */
export const INVALID_ORDER_ITEM: String[] = [
  ImportOrderValidationErrorTypeEnum.MINOR_ERROR_1001,
  ImportOrderValidationErrorTypeEnum.MINOR_ERROR_1002,
  ImportOrderValidationErrorTypeEnum.CRITICAL_ERROR_100,
  ImportOrderValidationErrorTypeEnum.CRITICAL_ERROR_101,
  ImportOrderValidationErrorTypeEnum.CRITICAL_ERROR_102,
  ImportOrderValidationErrorTypeEnum.CRITICAL_ERROR_103,
  ImportOrderValidationErrorTypeEnum.CRITICAL_ERROR_104,
  ImportOrderValidationErrorTypeEnum.CRITICAL_ERROR_105,
  ImportOrderValidationErrorTypeEnum.CRITICAL_ERROR_106,
  ImportOrderValidationErrorTypeEnum.CRITICAL_ERROR_1000,
  ImportOrderValidationErrorTypeEnum.CRITICAL_ERROR_1003,
  ImportOrderValidationErrorTypeEnum.CRITICAL_ERROR_1004,
  ImportOrderValidationErrorTypeEnum.CRITICAL_ERROR_1005,
  ImportOrderValidationErrorTypeEnum.CRITICAL_ERROR_1006,
  ImportOrderValidationErrorTypeEnum.CRITICAL_ERROR_1008,
  ImportOrderValidationErrorTypeEnum.CRITICAL_ERROR_1009,
  ImportOrderValidationErrorTypeEnum.CRITICAL_ERROR_1010,
  ImportOrderValidationErrorTypeEnum.CRITICAL_ERROR_1011,
  ImportOrderValidationErrorTypeEnum.CRITICAL_ERROR_1012,
];
